export default {
  bar: 0,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0
}



// WEBPACK FOOTER //
// ./src/components/Vuetify/mixins/application.js